import controller from './campaign.controller';
import template from './campaign.html';
import './campaign.scss';
/**
 * @ngdoc component
 * @name campaign
 * @description
 * The campaign component of the app.
 *
 * @memberof campaigns
 */
export default {
  /**
   * The controller class for the component.
   * @type {CampaignController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String} campaignId  ID of the campaign to be edited.
   */
  bindings: {
    campaignId: '@',
  },
};



// WEBPACK FOOTER //
// ./src/frontend/modules/campaigns/components/campaign/campaign.component.js